export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7499.f9be5cbb.jpg";